module.exports = __webpack_public_path__ + "img/VictoriaAccesoriosLogo.3908d4e2.png";